import { motion } from "framer-motion";
import { MathRichText } from "@/lib/mathRichText";

interface Props {
  data: { type: "example"; label?: string; content: string; animation?: string };
  isChildTheme?: boolean;
}

export function ElementExample({ data, isChildTheme }: Props) {
  const child = !!isChildTheme;
  return (
    <motion.div
      className={
        child
          ? "lp-example-child rounded-2xl border-[2.5px] border-amber-300 py-4 px-5 shadow-lg"
          : "rounded-lg border-l-4 border-amber-400 bg-amber-50 py-2 px-4"
      }
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      {data.label && (
        <div
          className={
            child
              ? "font-extrabold text-amber-950 text-base mb-2 drop-shadow-sm"
              : "font-semibold text-amber-800 text-sm"
          }
        >
          <MathRichText text={data.label} />
        </div>
      )}
      <div className={child ? "lp-example-text text-slate-900 leading-snug" : "text-slate-800 text-sm"}>
        <MathRichText text={data.content} highlightVocab isChild={child} />
      </div>
    </motion.div>
  );
}
